import * as h from "react";
import K from "react";
import { g as re } from "./chunk.CKXGCgA0.js";
import { _ as l, a as v, L as ie } from "./chunk.Czw-e4a5.js";
import ue from "@mui/material/useMediaQuery";
import { styled as L, useThemeProps as W } from "@mui/material/styles";
import { D as de, g as ce, f as pe, P as fe, a as O, h as q, w as B, j as me, m as Pe, x as Q, n as be, o as ye, y as V, s as De, u as he, b as U, c as Te, d as G, e as xe, z as ge, p as J, q as X, t as ve, v as Z, A as ke, B as Oe, E as Fe, F as Re, G as _e, H as Ce } from "./chunk.Kz7tWOuN.js";
import { jsx as P, jsxs as Me } from "react/jsx-runtime";
import { P as e } from "./chunk.C6tu0KW1.js";
import we from "@mui/material/Typography";
import { v as H, r as k } from "./chunk.Cr4FqO5B.js";
import $e from "@mui/material/TextField";
import Ie from "@mui/material/DialogContent";
import je from "@mui/material/Fade";
import ze, { dialogClasses as Y } from "@mui/material/Dialog";
const Ve = L(ze)({
  [`& .${Y.container}`]: {
    outline: 0
  },
  [`& .${Y.paper}`]: {
    outline: 0,
    minWidth: de
  }
}), Le = L(Ie)({
  "&:first-of-type": {
    padding: 0
  }
});
function We(o) {
  var s, u;
  const {
    children: r,
    onDismiss: i,
    open: d,
    slots: a,
    slotProps: n
  } = o, t = (s = a == null ? void 0 : a.dialog) != null ? s : Ve, c = (u = a == null ? void 0 : a.mobileTransition) != null ? u : je;
  return /* @__PURE__ */ P(t, l({
    open: d,
    onClose: i
  }, n == null ? void 0 : n.dialog, {
    TransitionComponent: c,
    TransitionProps: n == null ? void 0 : n.mobileTransition,
    PaperComponent: a == null ? void 0 : a.mobilePaper,
    PaperProps: n == null ? void 0 : n.mobilePaper,
    children: /* @__PURE__ */ P(Le, {
      children: r
    })
  }));
}
function Ae(o) {
  return pe("MuiDatePickerToolbar", o);
}
ce("MuiDatePickerToolbar", ["root", "title"]);
const Se = ["value", "isLandscape", "onChange", "toolbarFormat", "toolbarPlaceholder", "views", "className"], Ee = (o) => {
  const {
    classes: s
  } = o;
  return Pe({
    root: ["root"],
    title: ["title"]
  }, Ae, s);
}, Ne = L(fe, {
  name: "MuiDatePickerToolbar",
  slot: "Root",
  overridesResolver: (o, s) => s.root
})({}), qe = L(we, {
  name: "MuiDatePickerToolbar",
  slot: "Title",
  overridesResolver: (o, s) => s.title
})(({
  ownerState: o
}) => l({}, o.isLandscape && {
  margin: "auto 16px auto auto"
})), Be = /* @__PURE__ */ h.forwardRef(function(s, u) {
  const r = W({
    props: s,
    name: "MuiDatePickerToolbar"
  }), {
    value: i,
    isLandscape: d,
    toolbarFormat: a,
    toolbarPlaceholder: n = "––",
    views: t,
    className: c
  } = r, f = v(r, Se), p = O(), b = q(), m = Ee(r), y = h.useMemo(() => {
    if (!i)
      return n;
    const x = B(p, {
      format: a,
      views: t
    }, !0);
    return p.formatByString(i, x);
  }, [i, a, n, p, t]), T = r;
  return /* @__PURE__ */ P(Ne, l({
    ref: u,
    toolbarTitle: b.datePickerToolbarTitle,
    isLandscape: d,
    className: me(m.root, c)
  }, f, {
    children: /* @__PURE__ */ P(qe, {
      variant: "h4",
      align: d ? "left" : "center",
      ownerState: T,
      className: m.title,
      children: y
    })
  }));
});
function ee(o, s) {
  var u, r, i, d;
  const a = O(), n = Q(), t = W({
    props: o,
    name: s
  }), c = h.useMemo(() => {
    var p;
    return ((p = t.localeText) == null ? void 0 : p.toolbarTitle) == null ? t.localeText : l({}, t.localeText, {
      datePickerToolbarTitle: t.localeText.toolbarTitle
    });
  }, [t.localeText]), f = (u = t.slots) != null ? u : be(t.components);
  return l({}, t, {
    localeText: c
  }, ye({
    views: t.views,
    openTo: t.openTo,
    defaultViews: ["year", "day"],
    defaultOpenTo: "day"
  }), {
    disableFuture: (r = t.disableFuture) != null ? r : !1,
    disablePast: (i = t.disablePast) != null ? i : !1,
    minDate: V(a, t.minDate, n.minDate),
    maxDate: V(a, t.maxDate, n.maxDate),
    slots: l({
      toolbar: Be
    }, f),
    slotProps: (d = t.slotProps) != null ? d : t.componentsProps
  });
}
const Ue = (o) => {
  var s, u, r;
  const i = O(), d = Q();
  return l({}, o, {
    disablePast: (s = o.disablePast) != null ? s : !1,
    disableFuture: (u = o.disableFuture) != null ? u : !1,
    format: (r = o.format) != null ? r : i.formats.keyboardDate,
    minDate: V(i, o.minDate, d.minDate),
    maxDate: V(i, o.maxDate, d.maxDate)
  });
}, He = ({
  props: o,
  inputRef: s
}) => {
  const u = Ue(o), {
    forwardedProps: r,
    internalProps: i
  } = De(u, "date");
  return he({
    inputRef: s,
    forwardedProps: r,
    internalProps: i,
    valueManager: U,
    fieldValueManager: Te,
    validator: H,
    valueType: "date"
  });
}, Ke = ["components", "componentsProps", "slots", "slotProps", "InputProps", "inputProps"], Ye = ["inputRef"], Qe = ["ref", "onPaste", "onKeyDown", "inputMode", "readOnly", "clearable", "onClear"], oe = /* @__PURE__ */ h.forwardRef(function(s, u) {
  var r, i, d;
  const a = W({
    props: s,
    name: "MuiDateField"
  }), {
    components: n,
    componentsProps: t,
    slots: c,
    slotProps: f,
    InputProps: p,
    inputProps: b
  } = a, m = v(a, Ke), y = a, T = (r = (i = c == null ? void 0 : c.textField) != null ? i : n == null ? void 0 : n.TextField) != null ? r : $e, x = G({
    elementType: T,
    externalSlotProps: (d = f == null ? void 0 : f.textField) != null ? d : t == null ? void 0 : t.textField,
    externalForwardedProps: m,
    ownerState: y
  }), {
    inputRef: F
  } = x, D = v(x, Ye);
  D.inputProps = l({}, b, D.inputProps), D.InputProps = l({}, p, D.InputProps);
  const w = He({
    props: D,
    inputRef: F
  }), {
    ref: A,
    onPaste: $,
    onKeyDown: g,
    inputMode: I,
    readOnly: S,
    clearable: R,
    onClear: E
  } = w, _ = v(w, Qe), {
    InputProps: j,
    fieldProps: z
  } = xe({
    onClear: E,
    clearable: R,
    fieldProps: _,
    InputProps: _.InputProps,
    slots: c,
    slotProps: f,
    components: n,
    componentsProps: t
  });
  return /* @__PURE__ */ P(T, l({
    ref: u
  }, z, {
    InputProps: l({}, j, {
      readOnly: S
    }),
    inputProps: l({}, _.inputProps, {
      inputMode: I,
      onPaste: $,
      onKeyDown: g,
      ref: A
    })
  }));
}), te = /* @__PURE__ */ h.forwardRef(function(s, u) {
  var r, i, d, a;
  const n = q(), t = O(), c = ee(s, "MuiDesktopDatePicker"), f = l({
    day: k,
    month: k,
    year: k
  }, c.viewRenderers), p = l({}, c, {
    viewRenderers: f,
    format: B(t, c, !1),
    yearsPerRow: (r = c.yearsPerRow) != null ? r : 4,
    slots: l({
      openPickerIcon: ge,
      field: oe
    }, c.slots),
    slotProps: l({}, c.slotProps, {
      field: (m) => {
        var y;
        return l({}, J((y = c.slotProps) == null ? void 0 : y.field, m), X(c), {
          ref: u
        });
      },
      toolbar: l({
        hidden: !0
      }, (i = c.slotProps) == null ? void 0 : i.toolbar)
    })
  }), {
    renderPicker: b
  } = ve({
    props: p,
    valueManager: U,
    valueType: "date",
    getOpenDialogAriaText: (d = (a = p.localeText) == null ? void 0 : a.openDatePickerDialogue) != null ? d : n.openDatePickerDialogue,
    validator: H
  });
  return b();
});
te.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: e.bool,
  /**
   * Class name applied to the root element.
   */
  className: e.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: e.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: e.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: e.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: e.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: e.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: e.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: e.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: e.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: e.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: e.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: e.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Z,
  /**
   * The label content.
   */
  label: e.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: e.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: e.object,
  /**
   * Maximal selectable date.
   */
  maxDate: e.any,
  /**
   * Minimal selectable date.
   */
  minDate: e.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: e.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: e.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: e.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: e.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: e.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: e.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: e.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: e.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: e.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: e.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: e.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: e.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: e.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: e.oneOf(["landscape", "portrait"]),
  readOnly: e.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: e.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: e.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: e.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: e.oneOfType([e.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), e.number, e.shape({
    endIndex: e.number.isRequired,
    startIndex: e.number.isRequired
  })]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: e.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: e.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: e.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: e.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: e.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: e.shape({
    day: e.func,
    month: e.func,
    year: e.func
  }),
  /**
   * Available views.
   */
  views: e.arrayOf(e.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: e.oneOf([3, 4])
};
const Ge = ["props", "getOpenDialogAriaText"], Je = (o) => {
  var s, u, r;
  let {
    props: i,
    getOpenDialogAriaText: d
  } = o, a = v(o, Ge);
  const {
    slots: n,
    slotProps: t,
    className: c,
    sx: f,
    format: p,
    formatDensity: b,
    timezone: m,
    name: y,
    label: T,
    inputRef: x,
    readOnly: F,
    disabled: D,
    localeText: w
  } = i, A = O(), $ = h.useRef(null), g = ke(), I = (s = t == null || (u = t.toolbar) == null ? void 0 : u.hidden) != null ? s : !1, {
    open: S,
    actions: R,
    layoutProps: E,
    renderCurrentView: _,
    fieldProps: j
  } = Oe(l({}, a, {
    props: i,
    inputRef: $,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "mobile"
  })), z = n.field, C = G({
    elementType: z,
    externalSlotProps: t == null ? void 0 : t.field,
    additionalProps: l({}, j, I && {
      id: g
    }, !(D || F) && {
      onClick: R.onOpen,
      onKeyDown: Fe(R.onOpen)
    }, {
      readOnly: F ?? !0,
      disabled: D,
      className: c,
      sx: f,
      format: p,
      formatDensity: b,
      timezone: m,
      label: T,
      name: y
    }),
    ownerState: i
  });
  C.inputProps = l({}, C.inputProps, {
    "aria-label": d(j.value, A)
  });
  const ne = l({
    textField: n.textField
  }, C.slots), le = (r = n.layout) != null ? r : Re, se = _e($, C.inputRef, x);
  let N = g;
  I && (T ? N = `${g}-label` : N = void 0);
  const M = l({}, t, {
    toolbar: l({}, t == null ? void 0 : t.toolbar, {
      titleId: g
    }),
    mobilePaper: l({
      "aria-labelledby": N
    }, t == null ? void 0 : t.mobilePaper)
  });
  return {
    renderPicker: () => /* @__PURE__ */ Me(ie, {
      localeText: w,
      children: [/* @__PURE__ */ P(z, l({}, C, {
        slots: ne,
        slotProps: M,
        inputRef: se
      })), /* @__PURE__ */ P(We, l({}, R, {
        open: S,
        slots: n,
        slotProps: M,
        children: /* @__PURE__ */ P(le, l({}, E, M == null ? void 0 : M.layout, {
          slots: n,
          slotProps: M,
          children: _()
        }))
      }))]
    })
  };
}, ae = /* @__PURE__ */ h.forwardRef(function(s, u) {
  var r, i, d;
  const a = q(), n = O(), t = ee(s, "MuiMobileDatePicker"), c = l({
    day: k,
    month: k,
    year: k
  }, t.viewRenderers), f = l({}, t, {
    viewRenderers: c,
    format: B(n, t, !1),
    slots: l({
      field: oe
    }, t.slots),
    slotProps: l({}, t.slotProps, {
      field: (b) => {
        var m;
        return l({}, J((m = t.slotProps) == null ? void 0 : m.field, b), X(t), {
          ref: u
        });
      },
      toolbar: l({
        hidden: !1
      }, (r = t.slotProps) == null ? void 0 : r.toolbar)
    })
  }), {
    renderPicker: p
  } = Je({
    props: f,
    valueManager: U,
    valueType: "date",
    getOpenDialogAriaText: (i = (d = f.localeText) == null ? void 0 : d.openDatePickerDialogue) != null ? i : a.openDatePickerDialogue,
    validator: H
  });
  return p();
});
ae.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: e.bool,
  /**
   * Class name applied to the root element.
   */
  className: e.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: e.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: e.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: e.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: e.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: e.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: e.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: e.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: e.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: e.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: e.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: e.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: e.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: e.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: e.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: e.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Z,
  /**
   * The label content.
   */
  label: e.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: e.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: e.object,
  /**
   * Maximal selectable date.
   */
  maxDate: e.any,
  /**
   * Minimal selectable date.
   */
  minDate: e.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: e.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: e.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: e.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: e.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: e.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: e.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: e.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: e.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: e.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: e.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: e.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: e.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: e.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: e.oneOf(["landscape", "portrait"]),
  readOnly: e.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: e.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: e.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: e.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: e.oneOfType([e.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), e.number, e.shape({
    endIndex: e.number.isRequired,
    startIndex: e.number.isRequired
  })]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: e.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: e.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: e.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: e.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: e.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: e.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: e.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: e.shape({
    day: e.func,
    month: e.func,
    year: e.func
  }),
  /**
   * Available views.
   */
  views: e.arrayOf(e.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: e.oneOf([3, 4])
};
const Xe = ["desktopModeMediaQuery"], Ze = /* @__PURE__ */ h.forwardRef(function(s, u) {
  const r = W({
    props: s,
    name: "MuiDatePicker"
  }), {
    desktopModeMediaQuery: i = Ce
  } = r, d = v(r, Xe);
  return ue(i, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ P(te, l({
    ref: u
  }, d)) : /* @__PURE__ */ P(ae, l({
    ref: u
  }, d));
});
function bo(o) {
  const s = K.useRef(null), u = (a) => {
    const { helperText: n } = o;
    if (a)
      return typeof n == "string" ? n : typeof n == "function" ? n(a) : void 0;
  }, r = (a) => {
    var c, f, p;
    const n = (c = a == null ? void 0 : a.InputProps) == null ? void 0 : c.ref, t = (f = n == null ? void 0 : n.current) == null ? void 0 : f.firstElementChild;
    return (p = t == null ? void 0 : t.placeholder) == null ? void 0 : p.toLowerCase();
  }, i = (a) => {
    o.onChange && o.onChange(a);
  };
  function d() {
    var a;
    if (s.current) {
      const n = {
        target: s.current
      };
      (a = o.onBlur) == null || a.call(o, n);
    }
  }
  return /* @__PURE__ */ K.createElement(
    Ze,
    {
      inputRef: s,
      label: o.label,
      disabled: o.disabled,
      readOnly: o.readOnly,
      value: o.value,
      minDate: o.minDate,
      maxDate: o.maxDate,
      onChange: i,
      onError: o.onError,
      onClose: d,
      slotProps: {
        textField: (a) => ({
          id: o.id,
          autoFocus: o.autoFocus,
          helperText: u(r(a)),
          error: o.error || (a == null ? void 0 : a.error),
          inputProps: {
            "data-testid": o["data-testid"]
          },
          required: o.required,
          onBlur: o.onBlur,
          fullWidth: o.fullWidth,
          // this doesn't seem to work, so the sx below helps out
          sx: {
            maxWidth: o.fullWidth ? "100%" : void 0
          },
          clearable: o.clearable,
          size: re(o.size)
        })
      }
    }
  );
}
export {
  bo as D
};
